import { usePlanIsHiddenHotelQuestions as useIsHiddenHotelQuestions } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/is-hidden-hotel-questions/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const useDayTripPlanIsHiddenHotelQuestions = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDayTripPlanFormModelContext();
	const { isHiddenHotelQuestions } = viewModel;
	const { questions } = queryData.hotelPolicy;

	return useIsHiddenHotelQuestions({
		questions,
		isHiddenHotelQuestions,
		onSetViewModel,
	});
};
